module.exports = __webpack_public_path__ + "images/emoji/bar_chart.30cd800c433ad8af0f7c.png";